/**
 * Module: App
 *
 * Project based module for all custom Controllers, Services and Factories
 * directly related to this project.
 */
import 'core-js/stable' // polyfill
import 'regenerator-runtime/runtime' // async-wait
import '../analytics/app.adobe-analytics'
import '../solarcommercial/app.solarcom' // solar commercial calculator
import './usabilla/initiate.js' // Web chat and usabillia

// Custom modules created by Synergy/Meerkats converted to ESNext moudle syntax
import './alert'
import './affix'
import './articles'
import './charts'
import './date'
import './filter'
import './input-date'
import './mobile-navigation'
import './hero-gallery'
import './user-utilities'
import './smooth-scroll'
import './overflow-scroll'
import './toggle'
import './tabs'
import './predictive-search'
import './tooltip'
import './input-privacy'
import './editable-field'
import './radio-slider'
import './video-player'
import './input-file'
import './input-trim'
import './my-account'
import './analytics'
import './input-date'
import './form-analytics'
import './video-analytics'
import './tables'
import './icon'
import './mobile'
import './hover'
import './modal'
import './bindfile'
import './syVideoPlayer'
import './webchats'
import './validate-input-file'

// sitecore form and subsites
import '../sitecore-forms/index.js'
import '../microsite/app.ttoc';

angular
    .module('app', [
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngPlaceholder',
        'rzModule',
        '720kb.socialshare',
        'infinite-scroll',
        'angular.filter',
        'articles',
        'editableField',
        'mobileNavigation',
        'overflowScroll',
        'predictiveSearch',
        'radioSlider',
        'smoothScroll',
        'toggle',
        'tooltip',
        'tabs',
        'userUtilities',
        'videoPlayer',
        'syAffix',
        'syAlert',
        'syAnalytics',
        'syAdobeAnalytics',
        'syBindFile',
        'syCharts',
        'syDate',
        'syFile',
        'syFilter',
        'syFormAnalytics',
        'syHeroGallery',
        'syHover',
        'syIcon',
        'syInitiate', // usabilla and web chat
        'syInputDate',
        'syInputPrivacy',
        'syInputTrim',
        'syMobile',
        'syModal',
        'syMyAccount',
        'sySolarComCalculator',
        'syTable',
        'syValiadteInputFile',
        'syVideoAnalytics',
        'syVideoPlayer',
        'syWebChats', // legacy webchat
        'syForm',
        'syTtoc'
    ])
    .run(function () {
        if (document && document.documentMode) {
            var className = ['lt-ie', document.documentMode + 1].join('')
            angular.element(document.getElementsByTagName('html')).addClass(className)
        }
    })
